















































































































import { Component, Vue, PropSync } from "vue-property-decorator";
import { RatePlanAddOnService } from "@/shared/models/ratePlanModel";
import { AddOnServiceView } from "@/shared/models/addOnService";
import { ListModel } from "@/shared/models/listModel";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import { Action, Getter } from "vuex-class";
import {
  PriceCalculationMethodView,
  CalculationMethods,
} from "@/shared/models/priceCalculationMethods";

@Component({
  components: {
    RightDrawer,
  },
})
export default class RatePlanFormAddOnServices extends Vue {
  @PropSync("addOnServices") services?: RatePlanAddOnService[];

  calculationMethods = CalculationMethods;

  allServices: AddOnServiceView[] = [];
  pickedServices: RatePlanAddOnService[] = [];
  formOpen = false;

  get pickableItems() {
    return this.allServices
      .filter((x) => !this.services?.some((s) => s.addOnServiceId == x.id))
      .map((x) => {
        return {
          id: 0,
          addOnServiceId: x.id,
          addOnServiceName: x.name,
          defaultQuantity: 0,
          discountPercent: 0,
          guestCanChangeQuantity: false,
          isIncludedInPrice: false,
          calculationMethodId: x.calculationMethodId,
        };
      })
      .sort((a, b) => a.addOnServiceName.localeCompare(b.addOnServiceName));
  }

  async created() {
    if (
      (this.priceCalculationMethods?.length ?? 0) === 0 &&
      this.refreshPriceCalculationMethods
    ) {
      await this.refreshPriceCalculationMethods();
    }

    this.axios
      .get<ListModel<AddOnServiceView>>("addOnServices", {
          params: {
            excludeBookingFee: true
          },
        })
      .then(({ data }) => {
        this.allServices = data.result;
      });
  }

  headers = [
    { text: "AddOnService.Name", value: "addOnServiceName", align: "center" },
    {
      text: "RatePlans.AddOnService.DefaultQuantity",
      value: "defaultQuantity",
      align: "center",
    },
    {
      text: "RatePlans.AddOnService.DiscountPercent",
      value: "discountPercent",
      align: "center",
    },
    {
      text: "RatePlans.AddOnService.IsIncludedInPrice",
      value: "isIncludedInPrice",
      align: "center",
    },
    {
      text: "RatePlans.AddOnService.GuestCanChangeQuantity",
      value: "guestCanChangeQuantity",
      align: "center",
    },
    { text: "", value: "actions" },
  ];

  get translatedHeaders() {
    return this.headers.map((x) => ({
      ...x,
      text: this.$t(x.text),
    }));
  }

  removeService(item: RatePlanAddOnService) {
    this.services = this.services?.filter(
      (x) => x.addOnServiceId != item.addOnServiceId
    );
  }

  addServices() {
    if (!this.services) {
      this.services = [];
    }
    this.services.push(...this.pickedServices);
    this.pickedServices = [];
    this.formOpen = false;
  }

  rules = {
    Required: [
      (value: any) => !!value || value === 0 || this.$t("Validation.Required"),
    ],
    WholeNumbersOnly: (value: number) =>
      value == null ||
      value == undefined ||
      value % 1 == 0 ||
      this.$t("Validation.MustBeWholeNumber"),
    NoNegativeNumbers: (value: number) =>
      value == null ||
      value == undefined ||
      value >= 0 ||
      this.$t("Validation.MustBePositive"),
  };

  getCalculationMethod(id: number) {
    const method = this.priceCalculationMethods?.find((x) => x.id == id);
    if (!method) return "";

    return this.$t(method.textResourceKey);
  }

  @Action("codebooks/refreshPriceCalculationMethods")
  refreshPriceCalculationMethods?: () => Promise<void>;
  @Getter("codebooks/priceCalculationMethods")
  priceCalculationMethods?: PriceCalculationMethodView[];
}
